import styled from 'styled-components';

import * as palette from '../../../styles/variables';
import { Spin } from 'antd';

export const ComplexVersionTabsContainer = styled.div`
  padding-top: 10px;
  height: calc(100% - 60px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .ant-tabs-tabpane {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .ant-tabs-nav {
    color: rgb(255 255 255 / 0.65) !important;
    font-weight: 600 !important;
    .ant-tabs-tab-active {
      color: #ffffff !important;
      font-weight: 700 !important;
    }
    .ant-tabs-tab {
      &:active {
        color: #ffffff !important;
      }
      &:hover {
        color: #ffffff !important;
      }
    }
  }
  .ant-tabs-ink-bar {
    background-color: #ffffff !important;
  }
  .ant-tabs-bar {
    border-bottom: #ffffff00 !important;
    height: 24px;
  }
  .ant-tabs-content {
    height: calc(100% - 40px);
  }
  .ant-tabs-nav-wrap {
    text-align: center;
  }
  .deleteButton {
    background: ${palette.APP_BRAND_YELLOW_COLOR};
    width: 200px;
    height: 40px;
    text-align: center;
    border: 2px solid ${palette.APP_BRAND_YELLOW_COLOR};
    color: #000;
    font-weight: 600;
    border-radius: 5px;
    text-transform: uppercase;
    font-size: 12px;
    letter-spacing: 1px;
    z-index: 10 !important;
    &:hover,
    &:focus {
      border: 2px solid ${palette.APP_BRAND_YELLOW_COLOR};
      color: #000;
      background: ${palette.APP_BRAND_YELLOW_COLOR};
    }
  }
  .note-text {
    color: #fbfbfb;
    font-size: 14px;
    font-style: italic;
  }
  .button-container {
    padding: 12px;
    background: #0e1318;
    display: flex;
    justify-content: center;
  }
  .button-container div {
    width: fit-content;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .ant-timeline {
    overflow-y: scroll;
    height: 70vh;
    scroll-behavior: smooth;
    scrollbar-width: none;
    -ms-overflow-style: none;
    padding-top: 10px !important;
  }
  .ant-timeline::-webkit-scrollbar {
    display: none;
  }
`;

export const PublishList = styled.ul`
  padding: 20px;
  li {
    min-height: 60px;
    align-items: center;
    justify-content: flex-start;
    display: flex;
    font-size: 16px;
    color: #fff;
    cursor: pointer;
    transition: transform 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93) 0s;
    i {
      margin-right: 10px;
      font-size: 20px;
      color: #fff;
    }
    .column {
      display: flex;
      flex-direction: column;
    }
  }
  .note-text {
    font-size: 12px;
    color: hsla(0, 0%, 100%, 65%);
  }
  .active {
    color: #fff;
    transition: all 0.25s;
  }
`;

export const ListView = styled.li`
  ${props => props.activeVersion && `
    border: 1px solid #ffeb3b;
    border-radius: 12px;
    padding: 12px;
  `};
  ${props => props.isRejected && `
    border: 1px solid rgb(248, 92, 92);
  `};
    color: ${props => (props.activeVersion ? '#fff' : 'hsla(0,0%,100%,65%)')};
    // font-weight: ${props => props.activeVersion && '700'};
    font-weight: 600;
    font-size: 15px !important;
    transform: ${props => props.activeVersion && 'scale(1.05)'};
    transition: all .25s;
    @media only screen and (min-width: 1460px) {
      font-size: 17px !important;
    }
    i {
      color: ${props => (props.activeVersion ? '#fff' : 'hsla(0,0%,100%,65%)')};
    }
    pointer-events: ${props => props.disabled && 'none'};
    display: flex;
    justify-content: space-between !important;
    align-items: center;
    .env-name {
      display: flex;
    }
    .current-version {
      display: flex;
      justify-content: flex-end;
      gap: 6px;
    }
    .current-version i {
      margin-right: 0 !important;
    }
    .comment-button {
      margin-top: 6px;
      outline: none;
      border: none;
      padding: 0;
      background: transparent;
      font-size: 10px;
      text-decoration: underline;
      text-underline-position: under;
      cursor: pointer;
      :hover {
        text-decoration: none;
      }
    }
`;


export const Spinner = styled(Spin)`
  display: flex !important;
  gap:15px !important;
  align-items: center;
  justify-content: center !important;
  color: #fff !important;
   .ant-spin-dot-item {
    background-color: #fff !important;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  padding: 16px 28px;
  color: #fff;
  height: 100%;
  overflow-y: auto;
`;

export const Header = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  margin-bottom: 20px;
  text-decoration: underline;

  h3 {
    margin: 0;
    font-size: 18px;
    color: #fff;
  }

  .sort-dropdown {
    cursor: pointer;
    color: #fff;
    font-size: 13px;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 4px;

    &:hover {
      color: #ccc;
    }
  }
`;

export const Comment = styled.div`
  color: #ccc;
  font-size: 13px;
  margin-top: 4px;
  font-style: italic;
`;

export const TagsTitle = styled.div`
  width: 100%;
  padding: 0 20px 20px 20px;
  flex: 0 0 auto;
  .add-button {
    border: none;
    border-radius: 4px;
    padding: 4px;
    background: none;
    color: #ffffff;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s ease;
  }
  .add-button:hover {
    background: #0e1318;
  }
  .tags-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .tags-header h2 {
    margin: 0;
    color: #ffffff;
    font-size: 16px;
    font-weight: 600;
  }
`;

export const TagsList = styled.div`
  width: 100%;
  padding: 0 20px 20px 20px;
  flex: 1 1 auto;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
  .tag-item {
    border-radius: 8px;
    padding: 12px;
    cursor: pointer;
    transition: background 0.2s ease;
    color: #fff;
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;
  }
  .tag-item:hover, .active {
    background: #0e1318;
  }
  .tag-item h3 {
    margin: 0 0 4px 0;
    color: #ffffff;
    font-size: 14px;
    font-weight: 500;
  }
  .active h3 {
    font-weight: 600;
  }
  .tag-item p {
    margin: 0;
    color: #ffffffa6;
    font-size: 12px;
    font-style: italic;
  }
  .tags-empty {
    margin-block: 48px;
    color: #fff;
    text-align: center;
  }
  .delete-button {
    outline: none;
    border: none;
    position: absolute;
    top: 0;
    right: 0;
    border-radius: 0 8px 8px 0;
    height: 100%;
    width: 30px;
    background: rgba(248, 92, 92, 0.5);
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    transform: translateX(100%);
    cursor: pointer;
  }
  .tag-item:not(.active):hover .delete-button,
  .show-delete-option {
    transform: translateX(0);
    transition: transform 0.2s linear;
  }
  scrollbar-width: none; /* Firefox */
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const VersionTagPopup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  .tag-info {
    display: flex;
    gap: 12px;
  }
  h1 {
    font-size: 17px;
    font-weight: 600;
    text-transform: uppercase;
  }
  label {
    display: block;
  }
  .ant-select {
    min-width: 100px;
  }
  .ant-btn,
  .ant-btn:hover,
  .ant-btn:focus {
    margin-left: auto;
    min-width: 85px;
    background: #db391f;
    color: #fff;
    display: block;
  }
  .ant-btn:hover {
    opacity: 0.8;
    transform: scale(1.02);
    transition: transform 0.2s linear;
  }
  .ant-form-item {
    margin-bottom: 12px;
  }
  .ant-form-item-control {
    line-height: 32px;
  }
`;

export const NoAudit = styled.div`
  text-align: center;
`
export const TagsPopup = styled.div`
  .tag-input {
    margin-top: 4px;
    margin-bottom: 12px;
    border-radius: 6px;
  }

  .footer-btn {
    display: flex;
    justify-content: space-between;
  }

  .ant-popover-inner {
    outline: 1px solid grey !important;
    border-radius: 8px !important;
    padding: ${props => (props.rejection ? '10px' : '6px')} !important;
    height: ${props => (props.rejection ? '246px' : '200px')} !important;
  }
`;

export const VersioningProcess = styled.div`
  .versioning-btn-style {
    background-color: #ffeb3b !important;
    color: black !important;
    border-radius: 4px;
    border: none;
    margin-right: 6px;
    &.no-click {
      cursor:  default !important;
    }
  }
  .rejected-btn {
    background-color: red !important;
    color: white !important;
    border-radius: 5px;
    border: 1px solid red;
    margin-right: 8px;
    cursor: default !important;
    pointer-events: none !important;
  }
  .reject-btn {
    background-color: red !important;
    color: white !important;
    border-radius: 16px;
    border: 1px solid red;
    margin-right: 8px;
  }
`;


